export enum OnyxMapRoutePointStatus {
  TO_DO = 'to-do',
  WAITING = 'waiting',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}
